import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useMeetCompetitionSummaryData from '../../../state/meetCompetitionSummary/UseMeetCompetitionSummaryData';
import useOmeMeetData from '../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryData from '../../../state/omeMeetEntry/UseOmeMeetEntryData';

import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';
import ToIntIfInt from '@usas/ui-web/utils/ToIntIfInt';

const TAXONOMIES = ['MeetDetail', 'OUMeetDetail', 'AthleteMeetDetail'];
const SCOPE = 'Meet';

const useMeetTeamEntryById = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { targetMeetId } = useParams();
  const { meetState, getMeet } = useMeetData();
  const { meetCompetitionSummaryState, getMeetCompetitionSummary } = useMeetCompetitionSummaryData();
  const { omeMeetState, getOmeMeetByMeetId, clearOmeMeetObjData } = useOmeMeetData();
  const { omeMeetEntryState, getOmeMeetEntry, clearOmeMeetEntryObjData } = useOmeMeetEntryData();
  const { getContextSecurity, contextSecurityState } = useSecurityData();
  const meetId = ToIntIfInt(targetMeetId);

  //load time
  useEffect(() => {
    if (meetId > 0 && meetState.isObjLoading !== true && meetState.isObjLoaded !== true) {
      getMeet(meetId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetId, meetState]);

  useEffect(() => {
    if (meetId > 0 && meetCompetitionSummaryState.isObjLoading !== true && meetCompetitionSummaryState.isObjLoaded !== true) {
      getMeetCompetitionSummary(meetId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetId, meetCompetitionSummaryState]);

  useEffect(() => {
    if (meetState.isObjLoaded === true) {
      if (meetState.objData?.meetId > 0) {
        getOmeMeetByMeetId(meetState.objData?.meetId);
      } else {
        clearOmeMeetObjData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetState]);

  useEffect(() => {
    if (omeMeetState.isObjLoaded === true) {
      if (omeMeetState.objData?.omeMeetId > 0) {
        getOmeMeetEntry(omeMeetState.objData?.omeMeetId);
      } else {
        clearOmeMeetEntryObjData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetState]);

  //load security context
  useEffect(() => {
    if (meetState.isObjLoaded === true) {
      if (meetState.objData?.meetId > 0) {
        if (contextSecurityState.isObjLoading !== true && contextSecurityState.isObjLoaded !== true) {
          getContextSecurity(meetId, TAXONOMIES, SCOPE);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextSecurityState, meetState]);

  //navigate
  useEffect(() => {
    if (meetState.isObjLoaded === true && meetCompetitionSummaryState.isObjLoaded === true &&
      omeMeetState.isObjLoaded === true && omeMeetEntryState.isObjLoaded === true) {
      if (contextSecurityState.isObjLoaded === true) {
        if (contextSecurityState.contextId === meetId && contextSecurityState.scope === 'Meet') {
          navigate(NavLinks.MEET_ENTRY_TEAM, { state: { teamEntry: location.state.teamEntry } });
        } else {
          navigate(NavLinks.MEET_SEARCH);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetState, meetCompetitionSummaryState, contextSecurityState, omeMeetState, omeMeetEntryState]);

  return {};
};

export default useMeetTeamEntryById;
